export default {
  CHANGE_MAIN_MENU (state, mainMenu) {
    state.mainMenu = mainMenu
  },
  CHANGE_MENU_HIDE (state, menuHide) {
    state.menuHide = menuHide
  },
  INCREASE_MAX_ZINDEX (state) {
    return ++state.zIndex
  },
  SHOW_ALERT (state, param) {
    state.alert = {
      show: true,
      msg: param.msg,
      title: param.tt,
      ok: param.ok
    }
  },
  HIDE_ALERT (state) {
    state.alert.show = false
  },
  SHOW_CONFIRM (state, param) {
    state.confirm = {
      show: true,
      msg: param.msg,
      title: param.title,
      ok: param.ok,
      cancel: param.cancel
    }
  },
  HIDE_CONFIRM (state) {
    state.confirm.show = false
  },
  SHOW_LOADING (state, param = '提交中') {
    if (typeof param === 'string') {
      param = {
        msg: param
      }
    }
    state.loading = {
      show: true,
      msg: param.msg,
      html: param.html
    }
  },
  HIDE_LOADING (state) {
    state.loading.show = false
  },
  SHOW_TOAST (state, param) {
    state.toast = {
      show: true,
      msg: param.msg,
      timeout: param.timeout || 1500
    }
  },
  HIDE_TOAST (state) {
    state.toast.show = false
  },
  SHOW_SELECT_IMG_WIN (state, config) {
    state.selectImgWin = Object.assign({}, config, {
      show: true
    })
  },
  HIDE_SELECT_IMG_WIN (state) {
    state.selectImgWin = {
      show: false
    }
  },
  SHOW_SELECT_VIDEO_WIN (state, config) {
    state.selectVideoWin = Object.assign({}, config, {
      show: true
    })
  },
  HIDE_SELECT_VIDEO_WIN (state) {
    state.selectVideoWin = {
      show: false
    }
  },
  SHOW_SELECT_AUDIO_WIN (state, config) {
    state.selectAudioWin = Object.assign({}, config, {
      show: true
    })
  },
  HIDE_SELECT_AUDIO_WIN (state) {
    state.selectAudioWin = {
      show: false
    }
  },
  SHOW_SELECT_ARTICLE_WIN (state, config) {
    state.selectArticleWin = Object.assign({}, config, {
      show: true
    })
  },
  HIDE_SELECT_ARTICLE_WIN (state) {
    state.selectArticleWin = {
      show: false
    }
  },
  SHOW_SELECT_MODEL3D_WIN (state, config) {
    state.selectModel3dWin = Object.assign({}, config, {
      show: true
    })
  },
  HIDE_SELECT_MODEL3D_WIN (state) {
    state.selectModel3dWin = {
      show: false
    }
  },

  SHOW_SELECT_UNITY3D_WIN (state, config) {
    state.selectUnity3dWin = Object.assign({}, config, {
      show: true
    })
  },
  HIDE_SELECT_UNITY3D_WIN (state) {
    state.selectUnity3dWin = {
      show: false
    }
  },

  REFRESH_GROUPS (state, g) {
    state.groups = g.groups.reverse()
  },
  ADD_GROUP (state, g) {
    if (g) {
      state.groups.push(g)
    }
  },

  SHOW_PLAYER (state, param) {
    // src, poster, title
    state.player = {
      show: true,
      src: param.src,
      poster: param.poster,
      title: param.title || '视频预览',
      autoPlay: param.autoPlay
    }
  },
  HIDE_PLAYER (state) {
    state.player.show = false
  },
  INIT_LOGIN_USER (state, user) {
    state.loginUser = user
  },
  SHOW_UPLOAD_IMG_WIN (state, config) {
    state.uploadImgWin = true
    state.uploadImgWinConfig = config || {}
  },
  HIDE_UPLOAD_IMG_WIN (state) {
    state.uploadImgWin = false
    state.uploadImgWinConfig = {}
  },
  GET_PERMISSION (state, param) {
    state.permission = param
  },
  SET_CURRENTGROUP (state, group) {
    state.currentGroup = group
    localStorage.setItem('group', group.objectId)
  }
}
